module.exports = __webpack_public_path__ + "static/image2-0589fd43062e419f33dbf4f27d53729a.jpg";